import AppStoreBadge from '@/assets/images/auth-promo/badge-app-store.svg';
import AppStoreBrandBadge from '@/assets/images/auth-promo/badge-app-store-brand.svg';
import GooglePlayBadge from '@/assets/images/auth-promo/badge-google-play.svg';
import GooglePlayBrandBadge from '@/assets/images/auth-promo/badge-google-play-brand.svg';
import { type MobileStore, STORE_URLS } from '@/shared/constants/app-stores';

import { StoreBadgeLink } from './store-badge.styled';

const BADGES = {
  'app-store': {
    default: AppStoreBadge,
    brand: AppStoreBrandBadge,
    label: 'Download on the App Store',
  },
  'google-play': {
    default: GooglePlayBadge,
    brand: GooglePlayBrandBadge,
    label: 'Get it on Google Play',
  },
} as const;

export const StoreBadge = ({
  store,
  tone = 'default',
}: {
  store: MobileStore;
  tone?: 'default' | 'brand';
}) => {
  const { [tone]: Badge, label } = BADGES[store];
  return (
    <StoreBadgeLink
      href={STORE_URLS[store]}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
    >
      <Badge aria-hidden="true" focusable="false" />
    </StoreBadgeLink>
  );
};
